import React, { useState } from 'react';
import { Confirm } from 'semantic-ui-react';
import { NodesModal } from '../../../Shared';
import { FormNodes } from '../FormNodes';
import { NodesAPI } from '../../../../api';
import { VscCheck, VscEdit, VscChromeClose } from "react-icons/vsc";
import { useAuth } from '../../../../hooks';
import './ItemNodes.css';
import { useParams } from "react-router";

const nodesController = new NodesAPI();

export function ItemNodes(props) {
    const { key, node, onReload } = props;
    const { statusNodes } = useParams();
    const { accessToken } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [isDelete, setIsDelete] = useState(false);

    const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
    const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

    const openUpdateNode = () => {
        setTitleModal(`Update Node`)
        onOpenCloseModal();
    };

    const openApproveNodeConfirm = () => {
        setIsDelete(false);
        setConfirmMessage(
            node.status === 'APPROVE'
                ? `Delete Node`
                : `Approve Node`
        );
        onOpenCloseConfirm()
    };

    const onApproveNodeConfirm = async () => {
        try {
            await nodesController.approveNode(accessToken, node._id);
            onOpenCloseConfirm();
            onReload();
        } catch (error) {
            console.error(error);
        }
    };

    const openDeleteNodeConfirm = () => {
        setIsDelete(true);
        setConfirmMessage(`Delete Node`)
        onOpenCloseConfirm()
    };

    const onDelete = async () => {
        try {
            await nodesController.deleteNode(accessToken, node._id);
            onOpenCloseConfirm();
            onReload();
        } catch (error) {
            console.error(error);
        }
    };

  return (
    <>
        <tbody>
            <tr className='nodes-item__body' key={key}>
                <td className='nodes-item__body-entity'>{node.entity}</td>
                <td>{node.networkId}</td>
                <td>{node.networkName}</td>
                <td className='nodes-item__body-techContact'>{node.nameTechnicalContact}</td>
                <td className='nodes-item__body-bussContact'>{node.nameBussinesContact}</td>
                <td className='nodes-item__body-bussContact'>{node.datePermissioning}</td>
                <td>
                    <div className='nodes-item_buttons-actions'>
                            <button className='bttn-update' icon="true" onClick={openUpdateNode}>
                                <VscEdit  size="20" />
                            </button>
                            { statusNodes ==="PENDING" ? 
                            <button className='bttn-check' icon="true" onClick={openApproveNodeConfirm}>
                                <VscCheck size="20" />
                            </button>
                              :
                              <></>
                              }
                            
                            <button className='bttn-delete' icon="true" onClick={openDeleteNodeConfirm}>
                                <VscChromeClose size="20" />
                            </button>
                    </div>
                </td>
            </tr>
        </tbody>

        <NodesModal show={showModal} close={onOpenCloseModal} title={titleModal}>
            <FormNodes
                close={onOpenCloseModal}
                onReload={onReload}
                node={node}
            />
        </NodesModal>

        <Confirm 
            open={showConfirm}
            onCancel={onOpenCloseConfirm}
            onConfirm={isDelete ? onDelete : onApproveNodeConfirm}
            content={confirmMessage}
            size='tiny'
        />
    </>
  )
}
